<div class="close-opportunity-container" *ngIf="opportunityOpen$ | async; else opportunityClosed">
  <ng-container *ngIf="canCreateOrders$ | async" [ngTemplateOutlet]="createOrderButton" />
  <button mat-flat-button color="warn" class="button-spacing" (click)="closeOpportunity(false)">
    {{ 'FRONTEND.SALES_UI.COMMON.LOST' | translate }}
  </button>
  <button mat-flat-button color="accent" class="closed-won-attributes" (click)="closeOpportunity(true)">
    {{ 'FRONTEND.SALES_UI.COMMON.WON' | translate }}
  </button>
</div>

<ng-template #opportunityClosed>
  <div class="close-opportunity-container">
    <ng-container [ngTemplateOutlet]="createOrderButton" />
    <button mat-stroked-button class="button-spacing" (click)="reopenOpportunity()">
      {{ 'FRONTEND.SALES_UI.SALES_OPPORTUNITIES.REOPEN' | translate }}
    </button>
    <ng-container *ngIf="closedWon$ | async; else closedLost">
      <va-badge class="closed-info" color="green-solid">
        {{ 'FRONTEND.SALES_UI.SALES_OPPORTUNITIES.CLOSED_WON' | translate }}
      </va-badge>
    </ng-container>
    <ng-template #closedLost>
      <va-badge class="closed-info" color="red-solid">
        {{ 'FRONTEND.SALES_UI.SALES_OPPORTUNITIES.CLOSED_LOST' | translate }}
      </va-badge>
    </ng-template>
  </div>
</ng-template>

<ng-template #createOrderButton>
  <button
    *ngIf="opportunity$ | async as opportunity"
    mat-flat-button
    color="primary"
    class="button-spacing"
    (click)="createOrderAction(opportunity)"
  >
    {{ 'FRONTEND.SALES_UI.OPPORTUNITY_DETAILS.CREATE_ORDER' | translate }}
  </button>
</ng-template>
